import { isStatusValid, validatorConsultaSeguimentoOutro } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import {
  ConsultaSeguimentoPergunta05ExemplosEnum,
  ConsultaSeguimentoPergunta05Model,
} from './model-consultaSeguimentoPergunta05'
import {
  hasPergunta05ExemplosFalhouAnySim,
  hasPergunta05ExemplosPassouAnySim,
  isPergunta05ExemplosPassouAllNao,
} from './utils-consultaSeguimentoPergunta05'

export const validatorConsultaSeguimentoPergunta05 = createValidator<ConsultaSeguimentoPergunta05Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_05_HEADER: required,
    OUTRO: validatorConsultaSeguimentoOutro,
  },
  (values: ConsultaSeguimentoPergunta05Model, errors: ErrorObject<ConsultaSeguimentoPergunta05Model>) => {
    if (values?.PERGUNTA_05_HEADER === SimNaoEnum.SIM) {
      const hasAnySimExemplosFalhou = hasPergunta05ExemplosFalhouAnySim(values)

      const isExemplosPassouAllNao = isPergunta05ExemplosPassouAllNao(values.PERGUNTA_05_EXEMPLOS)
      const hasExemplosPassouAnySim = hasPergunta05ExemplosPassouAnySim(values.PERGUNTA_05_EXEMPLOS)

      const isPassouMissing = !(isExemplosPassouAllNao || hasExemplosPassouAnySim)

      errors.PERGUNTA_05_EXEMPLOS = {
        FALHOU: pergunta05ExemplosFalhouValidator(values?.PERGUNTA_05_EXEMPLOS?.FALHOU),
        PASSOU: isPassouMissing ? required(values?.PERGUNTA_05_EXEMPLOS?.PASSOU) : undefined,
      }

      if (hasAnySimExemplosFalhou && !isPassouMissing) {
        errors.PERGUNTA_05_DUAS_VEZES_POR_SEMANA = required(values?.PERGUNTA_05_DUAS_VEZES_POR_SEMANA)
      }
    }

    return errors
  }
)

const pergunta05ExemplosFalhouValidator = createValidator<
  Record<ConsultaSeguimentoPergunta05ExemplosEnum, SimNaoEnum> | undefined
>({
  MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS: required,
  MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS: required,
  MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS: required,
  AGITA_AS_MAOS_PERTO_DO_ROSTO: required,
})
